import { Fragment } from 'react'

function AccountProgressBar({ keyId, startDate, period, values, installmentType = 'daily' }) {
  const end = getLastDate(new Date(startDate), period, installmentType)

  // values[0] = paidCount, values[1] = unpaidCount
  const paidPct   = Math.min((values[0] / period) * 100, 100)
  const unpaidPct = Math.min((values[1] / period) * 100, 100)

  return (
    <Fragment key={keyId}>
      {/* Progress bar */}
      <div style={{ marginTop: 4 }}>
        {/* Numeric Indicator */}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'Inter, sans-serif' }}>
            {values[0]} / {period}
          </span>
          <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'Inter, sans-serif' }}>{period - values[0]} remaining</span>
        </div>
        <div style={{
          height: 8,
          backgroundColor: 'rgba(255,255,255,0.08)',
          borderRadius: 999,
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* Unpaid (overdue) bar — behind paid */}
          <div style={{
            position: 'absolute', top: 0, left: 0,
            width: `${unpaidPct}%`,
            height: '100%',
            background: 'linear-gradient(90deg, #ff6b6b, #ff4d6d)',
            borderRadius: 999,
            transition: 'width 0.5s ease',
          }} />
          {/* Paid bar — on top */}
          <div style={{
            position: 'absolute', top: 0, left: 0,
            width: `${paidPct}%`,
            height: '100%',
            background: 'linear-gradient(90deg, #0fd47a, #25d4ff)',
            borderRadius: 999,
            transition: 'width 0.5s ease',
            boxShadow: paidPct > 0 ? '0 0 8px rgba(15,212,122,0.4)' : 'none',
          }} />
        </div>

        {/* Labels */}
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          marginTop: 6,
        }}>
          <span style={{ fontSize: 10, color: '#4a5568' }}>
            {new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: '2-digit' })}
          </span>
          <span style={{ fontSize: 10, color: '#4a5568' }}>{end}</span>
        </div>
      </div>
    </Fragment>
  )
}

export default AccountProgressBar

export const getLastDate = (startDate, period, installmentType) => {
  let end = new Date(startDate.getTime());
  if (installmentType === 'monthly') {
    end.setMonth(end.getMonth() + Number(period));
  } else if (installmentType === 'weekly') {
    end.setDate(end.getDate() + (Number(period) * 7));
  } else {
    end.setDate(end.getDate() + Number(period));
  }
  return end.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: '2-digit' });
}